import { Grid, Paper } from "@mui/material";
import Loading from "../../UI/Loading";

const CatracaRegistroContadorView = ({ isLoading, listCRC }) => {
  return (
    <>
      {isLoading ? (
        <Loading description="Carregando Registro..." />
      ) : (
        <>
          {listCRC.length > 0 ? (
            <Grid
              component={Paper}
              size={3}
              sx={{ p: 3, backgroundColor: "#d2a993" }}
            >
              {listCRC.map((catracaRegistroContador) => (
                <>
                  <p>
                    {catracaRegistroContador?.entradaSaida} -{" "}
                    {catracaRegistroContador?.quantidade} registros
                  </p>
                </>
              ))}
            </Grid>
          ) : (
            <p>Nenhum Registro Encontrado</p>
          )}
        </>
      )}
    </>
  );
};

export default CatracaRegistroContadorView;
